import { useSubscriptionsStore } from "../../../Subscriptions/store/subscriptions";
import { useUserSubscriptions } from "../../hooks/useUserSubscriptions";
import { User } from "../../types/user";

export default function SubscriptionsTab({ user }: { user: User }) {
    const subscriptions = useSubscriptionsStore(state => state.subscriptions);

    const userSubs = useUserSubscriptions(subscriptions, {
        email: user.email ?? undefined,
        phone: user.phone ?? undefined,
      });

    console.log("User Subscriptions", userSubs);

    return (
        <div className="w-full bg-card rounded-xl p-4">
        <table className="w-full text-xs table-fixed">
            <thead className="border-b border-gray-400 text-gray-200">
                <tr>
                    <th className="w-1/10 text-center font-light py-2">Service</th>
                    <th className="w-1/10 text-center font-light py-2">Package</th>
                    <th className="w-1/10 text-center font-light py-2">Amount</th>
                    <th className="w-1/10 text-center font-light py-2">Date</th>
                    <th className="w-1/10 text-center font-light py-2">Status</th>
                    <th className="w-1/10 text-center font-light py-2">Action</th>
                </tr>
            </thead>

            <tbody className="text-white">
                {userSubs.map((sub, index) => (
                    <tr key={index} className="bg-card/50">
                        <td className="w-1/10 text-center py-2">{sub.service_name}</td>
                        <td className="w-1/10 text-center py-2">{sub.package_name}</td>
                        <td className="w-1/10 text-center py-2">MWK {sub.amount}</td>
                        <td className="w-1/10 text-center py-2">{sub.startDate}</td>
                        <td className="w-1/10 text-center py-2">{sub.status}</td>
                        <td className="w-1/10 text-center py-2">
                            <button className="bg-none border border-white text-white rounded-lg py-1 px-2 hover:scale-105 cursor-pointer">Deactivate</button>
                        </td>
                    </tr>
                ))}
                </tbody>
        </table>
        </div>
    );
}